export const InputsTheme = {
	variants: {
		mainInput: {
			field: {
				borderBottom: "4px solid rgb(236,122,29)",
				shadow: "none",
				borderRadius: "0px",
				fontSize: "1.2rem",
				marginTop: "12px",
				bg: "#ffffff",
				_hover: {
					borderBottom: "4px solid rgb(247, 158, 84)"
				},
				_focus: {
					borderBottom: "4px solid rgb(247, 158, 84)"
				}
			}
		}
	}
};
